// src/utils/constants.ts
// Brand constants — single source of truth
// Colors are defined in src/config/theme.ts → THEME.colors
export { THEME, withOpacity, getServiceColor, getDetailAccent } from '../config/theme';

export const BRAND = {
  name: 'Foretek Solution',
  tagline: 'Engineering the Future',
  email: 'info@foreteksolution.com',
  phone: '+91 8506820484',
  address: 'Greater Noida West',
  website: '',
};
